module.exports = __vendor;


//////////////////
// WEBPACK FOOTER
// external "__vendor"
// module id = 15
// module chunks = 0 1